@if (isDownloadingDocs()) {
  <section class="docs-loading-overlay" aria-live="polite" aria-label="Downloading documents">
    <app-loading-spinner [size]="48" />
  </section>
}

<h2 class="heading-4" data-testid="payment-title">
  <span data-testid="payment-cost">{{ vm.paymentCost | currency: 'GBP' | customRound }}</span>
  <span data-testid="payment-type-title"> {{ vm.paymentType }}</span>
</h2>

<p class="body mt-8" data-testid="payment-reason">{{ paymentReason }}</p>

<section class="what-is-this-payment" [class.open]="vm.panelExpanded">
  <section class="header">
    <button
      type="button"
      class="label flex gap-8 body large"
      (click)="panelExpanded.set(!vm.panelExpanded)"
      data-testid="what-is-this-payment-button"
    >
      <span> What is this payment? </span>

      <i
        class="fa-regular chevron"
        [class.fa-chevron-up]="vm.panelExpanded"
        [class.fa-chevron-down]="!vm.panelExpanded"
      ></i>
    </button>
  </section>

  <section [appAnimateOpen]="vm.panelExpanded" class="content" data-testid="what-is-this-payment-content">
    <section class="flex-col gap-8 full-width mt-8">
      @for (text of vm.paymentPanelDescription; track text) {
        <p class="body">{{ text }}</p>
      }

      <p class="body">
        <button
          (click)="downloadDocuments()"
          type="button"
          class="link-text"
          data-testid="download-documents-button"
          [disabled]="isDownloadingDocs()"
        >
          Your policy documents
        </button>
        include more details on your {{ vm.paymentType | lowercase }}, if needed. You can find these in the email or
        letter we sent you after purchase, and also in My Account.
      </p>
    </section>
  </section>
</section>

<section class="address mt-24">
  <app-checkbox
    [(ngModel)]="useHomeBillingAddress"
    (ngModelChange)="updateBillingAddress($event); getWorldpayDataUrl()"
    name="useHomeBillingAddress"
    data-testid="use-home-address-checkbox"
  >
    Use home address for billing
  </app-checkbox>

  @if (vm.useBillingAddress) {
    <section class="billing-address-display mt-16">
      <section>
        @for (line of vm.addressArray; track line; let index = $index) {
          <p class="hint" qmBlock data-testid="billing-address-display">
            @if ($index < vm.addressArray.length - 1) {
              {{ line.trim() + ',' }}
            } @else {
              {{ line.trim() }}
            }
          </p>
        }
      </section>
      <app-button
        class="change-billing-address"
        dataLabel="change-billing-address"
        data-testid="change-billing-address-button"
        [buttonOptions]="{
          variant: 'link-small',
        }"
        (click)="useBillingAddress.set(false)"
      >
        <span>Change</span>
        <i class="fa-light fa-edit ml-4"></i>
      </app-button>
    </section>
  }
</section>

@if (useHomeBillingAddress || vm.useBillingAddress) {
  @if (vm.worldPayDataLoading) {
    <section class="loading-worldpay" data-testid="loading-worldpay">
      <app-loading-spinner [size]="48" />
      <p class="body large">
        {{ initialPaymentLoad ? 'Connecting to Worldpay...' : 'Updating your payment details...' }}
      </p>
    </section>
  } @else if (vm.worldPayDataError) {
    Error!...
  } @else if (vm.putServiceOptionSubmitting) {
    <section class="loading-worldpay" data-testid="submitting-payment">
      <app-loading-spinner [size]="48" />
      <p class="body large">Sending your payment</p>
    </section>
  } @else {
    <section class="iframe" style="width: 395px; min-height: 500px" data-testid="payment-form-iframe-section">
      <section id="paymentForm"></section>
    </section>
  }
} @else {
  @if (billingAddressValue) {
    <app-address-lookup class="mt-12" (addressSaved)="saveBillingAddress($event)" data-testid="address-lookup" />
  }
}
